import { useState } from "react";
import {useHistory} from "react-router-dom/cjs/react-router-dom";
import axios from "axios";
import {ChatState} from "../../Context/ChatProvider";
import Eyeicon from "../../images/Eyeicon";


const SignUp = (props) => {
    const history = useHistory();
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
        pic: null
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading ] = useState(false);
    const [picLoading, setPicLoading ] = useState(false);
    const {showToast } = ChatState();
    const [showPassword, setShowPassword] = useState(false);

    const handleShow = () => setShowPassword(true);
    const handleHide = () => setShowPassword(false);


    const handleChange = (e) => {
        const { name, value } = e.target;
        const sanitizedValue = value.replace(/[<>&]/g, '');
        if (sanitizedValue !== value) {
            showToast('warning', 'Please avoid using <, >, & characters.');
        }
        setFormData(prevData => ({
            ...prevData,
            [name]: sanitizedValue,
        }));

        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: '',
        }));
    };
    const validateAlphanumeric = (name, value) => {
       if (name === 'password' || name==='confirmPassword') {
            if (value.length < 8) {
                return 'Password must be at least 8 characters long.'; 
            }
            const complexityRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/;
            if (!complexityRegex.test(value)) {
                return 'Must include upper-, lowercase letters and numbers.';
            }
            const allowedCharsRegex = /^[a-zA-Z0-9!@#$%^&*()_+=-]*$/;
            if (!allowedCharsRegex.test(value)) {
                return 'Password contains prohibited symbols.'; 
            }
        }
        if (name === 'name') {
            if (value.length < 6) {
                return 'Name should have minimum 6 symbols.'; 
            }
            const alphanumericRegex = /^[a-zA-Z0-9]*$/;
            if (!alphanumericRegex.test(value)) {
                return 'Only letters and numbers in name are allowed.';
            }
        }
        return '';
    };
    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            return 'Enter correct email.';
        }
        return '';
    };
    const handleBlur = (e) => {
        const { name, value } = e.target;
        let error = '';
        if (name === 'email') {
            error = validateEmail(value);
        } else if (name === 'pic') {
        } else {
            error = validateAlphanumeric(name, value);
        }

        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: error,
        }));
    
    };
    const submitHandler = async (e) => {
        e.preventDefault();
        if (loading) {return; }
        setLoading(true);
        const newErrors = {};
        setErrors({}); 
        for (const key in formData) {
            let error = '';
            if (key !== 'pic' && !formData[key]) {
                error = 'This field is required.';
            } else if (key === 'pic' && !formData.pic) {
                error = 'Please select a profile picture.';
            } else if (key === 'email') {
                error = validateEmail(formData[key]);
            } else if (key !== 'pic') {
                error = validateAlphanumeric(key, formData[key]);
            }
            if (error) {
                newErrors[key] = error;
                setErrors(newErrors);
                setLoading(false);
                showToast('danger', error); 
            }
        }


        if (formData.password !== formData.confirmPassword) {
            const errorMsg = 'Passwords do not match.';
            setErrors(prevErrors => ({ 
                ...prevErrors, 
                confirmPassword: errorMsg 
            }));
            showToast('danger', errorMsg);
            setLoading(false);
            return
        }

        try {
            const config = {
                headers: {"Content-type": "application/json" }
            };
            const { data } = await axios.post(
                 `${process.env.REACT_APP_API_URL}/api/user`,
                { name: formData.name, email: formData.email, password: formData.password, pic: formData.pic},
                config
            );
            showToast ( 'success', 'User ' + data.name + ' created! Go to your mailbox and confirm email.');
            localStorage.setItem("userInfo", JSON.stringify(data));
            setLoading(false);
            history.push("/");
        } catch (error) {
            if (error.response && error.response.status === 429) {
                showToast (
                    'info', 'If you have not received a verification email, please check your spam folder or try signing up again.'
                );
                setLoading(false);  
                return; 
            }
            showToast ('danger', ' Here is errorcreategroup' + (error.response && error.response.data.message
                ? error.response.data.message
                : error.message));
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    const postDetails =(pics)=>{
        setPicLoading(true);
        if(pics === undefined) {
            showToast ('warning', 'Please select an image!' );
            return;
        }
        if(pics.type === "image/jpeg" || pics.type === "image/png"  || pics.type === "image/jpg") {
            const data = new FormData();
            data.append("file", pics );
            data.append("upload_preset", "chat-app" );
            data.append("cloud_name", "dvxtzwyam" );
            fetch("https://api.cloudinary.com/v1_1/dvxtzwyam/image/upload", {
                method: "post",
                body: data
            }).then((res)=> res.json()).then((data)=> {
                const newInputs = {...formData};
                newInputs.pic = data.url.toString();
                setFormData( newInputs);
                console.log("errors.pic = ", errors.pic);
                errors.pic = "";
                setPicLoading(false);
            }).catch((err)=>{
                setPicLoading(false);
            });
        } else {
            showToast ( 'warning', 'Please select an image .png, .jpeg or .jpg format!');
            setPicLoading(false);
            return;
        }
    }
    const filledCount = Object.values(errors).filter(value => value !== "").length;
    
    return (
            <div className='loginFormBlock'>
                <h1 className='display1'>
                     <b> Sign Up</b>
                </h1>
                <form  id="first-name"  >
                    <div className='form-group'>
                        <label className='label p-2'>
                            <span className='text-base text-white'>Name</span>
                        </label>
                        <input
                            type='text'
                            placeholder='Enter nickname'
                            className={`updateInput ${errors.name ? 'input_error_border' : ''}`}
                            name='name'
                            value={formData.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        <span className='form_error'>{errors.name}</span>
                    </div>
                    <div>
                        <label className='label'>
                            <span className='text-base text-white'>E-mail</span>
                        </label>
                        <input
                            type='text'
                            placeholder='Enter e-mail'
                            className={`updateInput ${errors.email ? 'input_error_border' : ''}`}
                            name='email'
                            value={formData.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        <span className='form_error'>{errors.email}</span>
                    </div>

                    <div className="form_item">
                        <label className='label'>
                            <span className='text-base text-white'>Password</span>
                        </label>
                        <input
                            type={showPassword ? "text" : "password"}
                            placeholder='Enter password'
                            className={`updateInput ${errors.password ? 'input_error_border' : ''}`}
                            name='password'
                            value={formData.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        <button
                            type="button"
                            className="show_password"
                            onPointerDown={handleShow}
                            onPointerUp={handleHide}
                            onPointerLeave={handleHide}
                            onContextMenu={(e) => e.preventDefault()}
                        >
                            {showPassword ? <Eyeicon/> : <Eyeicon/>}
                        </button>
                        <span className='form_error'>{errors.password}</span>
                    </div>

                    <div className="form_item">
                        <label className='label'>
                            <span className='text-base text-white'>Confirm password</span>
                        </label>
                        <input
                            type={showPassword ? "text" : "password"}
                            placeholder='Confirm password'
                            className={`updateInput ${errors.confirmPassword ? 'input_error_border' : ''}`}
                            name='confirmPassword'
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        <button
                            type="button"
                            className="show_password"
                            onPointerDown={handleShow}
                            onPointerUp={handleHide}
                            onPointerLeave={handleHide}
                            onContextMenu={(e) => e.preventDefault()}
                        >
                            {showPassword ? <Eyeicon/> : <Eyeicon/>}
                        </button>
                        <span className='form_error'>{errors.confirmPassword}</span>
                    </div>

                    <div className='input_upload'>
                        <label className='label'>
                            <span className='text-base text-white'>Upload your picture</span>
                        </label>
                        <input type="file" className='inputFile' accept="image/*" onChange={(e)=>postDetails(e.target.files[0])} />
                        <p className='form_error'>{errors.pic}</p>
                    </div>
                    <div>
                        <button onClick={()=>props.setLoginSignup(true)} className='link_account'> Already have an account? </button>
                    </div>
                    <div className='signup_button'>
                        {errors &&  <div style={{ color: 'red' }}>{filledCount > 0 
                                        ?   <span > Form errors: {filledCount}. Please check the data.</span>
                                        : ""}
                                    </div>}
                        <button className='button' disabled={ loading || filledCount > 0} onClick={(e)=>submitHandler(e)}  type="button">
                            {loading ? <span className='loading loading-spinner'></span> : "Sign Up"}
                        </button>
                    </div>

                </form>
            </div>
    );
};
export default SignUp;